import React, { useState,  forwardRef, useContext, useEffect, useRef } from 'react';
import axios from 'axios';
import { AuthorizeContext } from "../RootContext";
import { Link, useParams } from 'react-router-dom';
import { api_url } from "../authorize";
import { createMuiTheme, makeStyles, ThemeProvider } from '@material-ui/core/styles';
import moment from 'moment';

import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import logo from './../img/lento_logo_transparent.png';

import MaterialTable from 'material-table';
import Button from '@material-ui/core/Button';
import AddBox from '@material-ui/icons/AddBox';
import ArrowUpward from '@material-ui/icons/ArrowUpward';
import Check from '@material-ui/icons/Check';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import ChevronRight from '@material-ui/icons/ChevronRight';
import Clear from '@material-ui/icons/Clear';
import DeleteOutline from '@material-ui/icons/DeleteOutline';
import Edit from '@material-ui/icons/Edit';
import FilterList from '@material-ui/icons/FilterList';
import FirstPage from '@material-ui/icons/FirstPage';
import LastPage from '@material-ui/icons/LastPage';
import Remove from '@material-ui/icons/Remove';
import SaveAlt from '@material-ui/icons/SaveAlt';
import Search from '@material-ui/icons/Search';
import ViewColumn from '@material-ui/icons/ViewColumn';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import FlagIcon from '@material-ui/icons/Flag';


const tableIcons = {
    Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
    Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
    Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
    DetailPanel: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
    Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
    Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
    FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
    LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
    NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    PreviousPage: forwardRef((props, ref) => <ChevronLeft {...props} ref={ref} />),
    ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Search: forwardRef((props, ref) => <Search {...props} ref={ref} fontSize="large"/>),
    SortArrow: forwardRef((props, ref) => <ArrowUpward {...props} ref={ref} />),
    ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
    ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />),
    Flag: forwardRef((props, ref) => <FlagIcon {...props} ref={ref} />),
  };

  const useStyles = makeStyles((muiTheme) => ({
    page: {
      minHeight: 'calc(100vh - 72px)',
      padding: '28px 20px 44px',
      boxSizing: 'border-box',
      background: '#f3f7f9',
      color: '#173247',
      fontFamily: 'Segoe UI, Tahoma, Arial, sans-serif',
      [muiTheme.breakpoints.down('sm')]: { padding: '20px 16px 32px' },
    },
    shell: { width: '100%', maxWidth: 'none', margin: 0 },
    pageHeader: {
      display: 'flex', alignItems: 'flex-end', justifyContent: 'space-between', gap: 20,
      marginBottom: 20, padding: 0, border: 'none', borderRadius: 0, background: 'transparent', boxShadow: 'none',
      [muiTheme.breakpoints.down('sm')]: { alignItems: 'flex-start', flexDirection: 'column', gap: 12 },
    },
    eyebrow: { margin: 0, color: '#0b819d', fontSize: 12, fontWeight: 800, letterSpacing: '0.10em', textTransform: 'uppercase' },
    title: {
      margin: '5px 0 0', color: '#173247', fontSize: 32, lineHeight: 1.15, fontWeight: 800, letterSpacing: '-0.025em',
      [muiTheme.breakpoints.down('xs')]: { fontSize: 27 },
    },
    subtitle: { maxWidth: 760, margin: '8px 0 0', color: '#607888', fontSize: 16, lineHeight: 1.55, fontWeight: 500 },
    headerMeta: { display: 'flex', alignItems: 'center', gap: 14, flexWrap: 'wrap', justifyContent: 'flex-end' },
    metaPill: {
      display: 'inline-flex', alignItems: 'center', gap: 7, minHeight: 0, padding: 0,
      borderRadius: 0, background: 'transparent', border: 'none', boxShadow: 'none',
      color: '#607888', fontSize: 14, fontWeight: 700, whiteSpace: 'nowrap',
    },
    metaDot: { width: 7, height: 7, borderRadius: '50%', background: '#0b819d' },
    card: {
      width: '100%', overflow: 'hidden', borderRadius: 16, border: '1px solid #dce7ec',
      background: '#ffffff', boxShadow: '0 16px 36px rgba(13, 46, 67, 0.08)',
      '& > .MuiPaper-root, & .MuiPaper-root': { boxShadow: 'none !important', borderRadius: '0 !important' },
      '& .MuiToolbar-root': { minHeight: '68px !important', padding: '10px 18px !important', borderBottom: '1px solid #e2ebef', background: '#ffffff' },
      '& .MuiTableContainer-root': { width: '100% !important', maxWidth: '100% !important', overflowX: 'hidden !important' },
      '& .MuiTable-root': { width: '100% !important', maxWidth: '100% !important', minWidth: '0 !important', tableLayout: 'fixed !important', fontFamily: 'Segoe UI, Tahoma, Arial, sans-serif !important' },
      '& .MuiTableCell-root': { boxSizing: 'border-box !important', minWidth: '0 !important', paddingLeft: '7px !important', paddingRight: '7px !important', overflow: 'hidden !important', fontFamily: 'Segoe UI, Tahoma, Arial, sans-serif !important' },
      '& .MuiTableCell-head': { paddingTop: '12px !important', paddingBottom: '12px !important', background: '#f1f6f8 !important', color: '#173247 !important', borderBottom: '1px solid #dce7ec !important', fontSize: '13px !important', fontWeight: '700 !important', lineHeight: '1.2 !important', whiteSpace: 'normal !important', wordBreak: 'normal !important', textAlign: 'center !important' },
      '& .MuiTableCell-body': { paddingTop: '11px !important', paddingBottom: '11px !important', borderBottom: '1px solid #edf1f3 !important', color: '#244154 !important', fontSize: '14px !important', fontWeight: '600 !important', lineHeight: '1.3 !important', verticalAlign: 'middle', whiteSpace: 'normal !important', overflowWrap: 'anywhere !important', textAlign: 'center !important' },
      '& .MuiTableBody-root .MuiTableRow-root:hover': { backgroundColor: '#f5fafb !important' },
      '& .MuiTableCell-body a': { color: '#176B5B', fontWeight: 700, textDecoration: 'underline', textDecorationColor: 'rgba(23, 107, 91, 0.42)', textUnderlineOffset: '2px' },
      '& .MuiInputBase-root': { color: '#244154', fontFamily: 'Segoe UI, Tahoma, Arial, sans-serif', fontSize: 14 },
      '& .MuiTablePagination-root': { borderTop: '1px solid #e2ebef', background: '#ffffff', color: '#607888' },
      '& .MuiIconButton-root': { color: '#49647d' },
      '& .MuiIconButton-root:hover': { background: '#eef7f9', color: '#0b819d' },
    },
    cardIntro: {
      display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 14,
      padding: '14px 18px', borderBottom: '1px solid #e2ebef', background: '#ffffff',
      [muiTheme.breakpoints.down('sm')]: { alignItems: 'flex-start', flexDirection: 'column' },
    },
    cardLabel: { margin: 0, color: '#173247', fontSize: 14, fontWeight: 800, letterSpacing: '0.01em' },
    cardHint: { margin: '3px 0 0', color: '#718897', fontSize: 13, fontWeight: 500 },
    actionButton: {
      minHeight: 38, padding: '0 15px', border: '1px solid #0b819d', borderRadius: 9,
      color: '#ffffff', background: '#0b819d', fontFamily: 'inherit', fontSize: 13, fontWeight: 700, cursor: 'pointer',
      '&:hover': { background: '#096f87' },
    },
    loadingScreen: { position: 'fixed', top: 72, right: 0, bottom: 0, left: 0, zIndex: 1200, display: 'flex', alignItems: 'center', justifyContent: 'center', overflow: 'hidden', background: '#ffffff' },
    loadingLogoWrap: { width: 'min(680px, 62vw)', maxWidth: 'calc(100vw - 48px)', display: 'flex', alignItems: 'center', justifyContent: 'center', [muiTheme.breakpoints.down('sm')]: { width: 'min(520px, 78vw)' }, [muiTheme.breakpoints.down('xs')]: { width: 'min(390px, 86vw)' } },
    loadingLogo: { display: 'block', width: '100%', height: 'auto', objectFit: 'contain', background: 'transparent', filter: 'none' },
    dialogPaper: { borderRadius: '16px !important' },
    dialogTitle: { margin: 0, color: '#243b52', fontSize: 20, fontWeight: 800, lineHeight: 1.25 },
    dialogText: { color: '#607888 !important', fontSize: '14px !important', lineHeight: '1.55 !important' },
    dialogActions: { gap: 10, padding: '12px 24px 22px !important' },
    dangerButton: { minWidth: 92, minHeight: 40, border: 0, borderRadius: 9, color: '#ffffff', background: '#b9473d', fontFamily: 'inherit', fontSize: 13, fontWeight: 700, cursor: 'pointer' },
    cancelButton: { minWidth: 92, minHeight: 40, border: '1px solid #d5e1e6', borderRadius: 9, color: '#49647d', background: '#ffffff', fontFamily: 'inherit', fontSize: 13, fontWeight: 700, cursor: 'pointer' },
  }));

  const tableStyles = makeStyles({
    root: {justifyContent: 'space-evenly'},
    spacing: {justifyContent: 'space-evenly'}

  });

  const theme = createMuiTheme({
    palette: {
      primary: { main: '#0b819d' },
      secondary: { main: '#18a39a' },
      background: { default: '#f4f7fb', paper: '#ffffff' },
    },
    typography: {
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Arial, sans-serif',
      h6: { fontWeight: 700 },
    },
    overrides: {
      MuiButton: {
        root: {
          textTransform: 'none',
          fontWeight: 700,
          borderRadius: 9,
        },
      },
      MuiIconButton: {
        root: { borderRadius: 9 },
      },
      MuiPaper: {
        rounded: { borderRadius: 14 },
      },
    },
  });

const FlagList = () => {
  const tableClass = tableStyles()
  const { token, role, user, authBody, setAuthenticated, setAuthBody } = useContext(AuthorizeContext);
  const [data, setData] = useState({})
  const [loading, setLoading] = useState(true);
  let { surgeonid } = useParams()
  const [profile, setProfile] = useState(authBody || {role: "visitor"})
  const hasRole = (profile, roles) =>{
    return roles.includes(profile.role)
  }
  console.log(data)
  useEffect(() => {
    const fetchData = async () => {
      const admin = await axios({
        url: `https://${api_url}/api/case_list?status=flag`,
        method: 'get',
        headers: {
          'x-access-token' : token
        }
      }).then(res=> {
        if(res.data.message){
          alert(res.data.message)
        }
        else if(res.data.validation){
          alert(res.data.validation.replace("_", " "))
        }
        else if(res.data.notLoggedIn){
          setAuthenticated(false)
          setAuthBody({role: 'visitor'})
          alert("You have been logged out due to inactivity. Please log in again.")
        }
        else{
          setLoading(false)
          setState((prevState) => ({
            ...prevState, data: res.data
          }))
        }
      });



    }
    fetchData();
  }, [setState]);

  let lookup = hasRole(profile, ['super_admin', 'write_admin', 'read_admin']) ?
    {
      2: 'MRI',
      3: 'MRI QC',
      4: 'Planning 1',
      5: 'Planning 2',
      6: 'Surgeon Approval',
      7: 'Template Design',
      8: 'G Code',
      9: 'CNC',
      10: 'Final QC',
      11: 'Shipped'
    } :

    {
      1: hasRole(profile, ['mri_center']) ? 'Ready to Upload MRI' : 'New Case',
      2: 'In Progress',
      3: 'In Progress',
      4: 'In Progress',
      5: 'In Progress',
      6: 'Approval Ready',
      7: 'Surgeon Approved',
      8: 'Surgeon Approved',
      9: 'Surgeon Approved',
      10: 'Surgeon Approved',
      11: 'Shipped'
    }


  const handleClose = () => {
    setState({...state, dialogFlagOpen: false});
  };

  const handleSlotClose = () => {
    setState({...state, dialogMessageOpen: false});

  }

  const handleSubmit = () => {
    axios({
      url: `https://${api_url}/api/case?case_id=${state.rowData.case_id}&update=remove_flag`,
      method: 'put',
      headers: {
        'x-access-token' : token
      }
    }).then(
      res => {
        if(res.data.message){
          alert(res.data.message)
          setState({...state, dialogFlagOpen: false})
        }
        else if(res.data.notLoggedIn){
          setAuthenticated(false)
          setAuthBody({role: 'visitor'})
          alert("You have been logged out due to inactivity. Please log in again.")
        }
        else{
        setState({...state, dialogFlagOpen: false})
        window.location.reload()
        }

      }
    );
  }

  const handleAssign = () => {
    axios({
      url: `https://${api_url}/api/assign_command`,
      method: 'post',
      headers: {
        'x-access-token' : token
      }
    }).then(
      res => {
        if(res.data.message){
          alert(res.data.message)
          setState({...state, dialogFlagOpen: false})
        }
        else{
        setState({...state, dialogFlagOpen: false})
        window.location.reload()
        }

      }
    );
  }


  const [state, setState] = useState({
    adminColumns: [
      { title: 'Case #', field:'case_id',  editable: "never", filtering: false, render:rowData => {
          return (
            <div>
            <Link type="text" to={`/case/${rowData.case_id}`}>{rowData.case_id}</Link>
            </div>
          )},
          cellStyle: {
            fontSize: '.7em'
          }
      },
      { title: 'Surgeon Name', field:'Surgeon.Last_Name', editable: "never", filterting: false, render: rowData => {
        return(
          <div>
            {rowData.Surgeon.Last_Name}, {rowData.Surgeon.First_Name} {rowData.Surgeon.Middle_Name}
          </div>
        )},
        cellStyle: {
          fontSize: '.7em'
        }
      },
      { title: 'Patient Name', field:'Patient.Last_Name', editable: "never", filtering: false, render: rowData => {
        return(
          <div>
            {rowData.Patient.Last_Name}, {rowData.Patient.First_Name}
          </div>
        )},
        cellStyle: {
          fontSize: '.7em'
        }
      },
      { title: 'DOPO', field:'dateCreated', editable: "never", filtering: 'false', type:'date',
        cellStyle:{
          fontSize: '.7em'
        },
          customSort: (a , b) => {
            a = moment(a.dateCreated).format();
            b = moment(b.dateCreated).format();
            return b > a ? 1 : -1;
          }
      },
      { title: 'DOS', field:'Patient.Date_of_Surgery', editable: "never", filtering: 'false', type: 'date',
        cellStyle: {
          fontSize: '.7em'
        },
          customSort: (a , b) => {
            a = moment(a.Patient.Date_of_Surgery).format();
            b = moment(b.Patient.Date_of_Surgery).format();
            return b > a ? 1 : -1;
          }
      },
      { title: 'Surgery Type', field:'Patient.Surgery_Type', editable: "never", filtering: 'false',
        cellStyle: {
          fontSize: '.7em'
        }
      },
      { title: 'Surgery Side', field:'Patient.Side_of_Body', editable: "never", filtering: 'false',
        cellStyle: {
          fontSize: '.7em'
        }
      },
      {
        title: 'Expedite', field: 'expedite', type: 'boolean', defaultSort: 'asc'
      },
      { title: 'Status', field:'case_status', filtering: 'false',
        lookup: lookup,
        emptyValue: "New Order",
        cellStyle:
          rowData =>
          {
            console.log(rowData)
            return(rowData !== 13 ?
                      ({background: 'linear-gradient(315deg, #045de9 0%, #09c6f9 74%)',
                        backgroundColor: "#045de9",
                        color: 'white',
                        textAlign: 'center',
                        fontSize: '.7em'})

                        :
                      ({
                        backgroundColor: "#990000",
                        backgroundImage: "linear-gradient(to right, #bdc3c7, #2c3e50)",
                        color: 'white',
                        textAlign: 'center',
                        fontSize: '.7em'
                      }))
          }

      },
      {
        title: 'Flag', field: 'flag_status', filtering: 'false', editable: 'never', type:"text", cellStyle:
        rowData =>
          {
            return(rowData.includes("no_flag") ?
              null

              :
              ({
                  background: "linear-gradient(to right, #ed213a, #93291e)",
                  backgroundColor: "#f46b45",
                  color: 'white',
                  textAlign: 'center',
                  fontSize: '.7em'
              }))
          }
      },
      {
        title: 'Expert Flag', field:'expert_flag', type: 'boolean', editable: 'never'
      },
      {
        title: 'User Assigned', field:'assigned', editable: 'never'
      },
      {
        title: 'Femur Slot', field: 'femur_slot', filtering: 'false', type: "boolean", emptyValue: <Check />,
        cellStyle: {
          textAlign: 'center'
        }
      },
      {
        title: 'Tibia Slot', field: 'tibia_slot', filtering: 'false', type: "boolean", emptyValue: <Check />,
        cellStyle: {
          textAlign: 'center'
        }
      }
    ],

    columns: [
      { title: 'Case #', field:'case_id',  editable: "never", filtering: false, render:rowData => {
          return (
            <div>
            <Link type="text" to={`/case/${rowData.case_id}`}>{rowData.case_id}</Link>
            </div>
          )},
          cellStyle: {
            fontSize: '.7em'
          }
      },
      { title: 'Surgeon Name', field:'Surgeon.Last_Name', editable: "never", filterting: false, render: rowData => {
        return(
          <div>
            {rowData.Surgeon.Last_Name}, {rowData.Surgeon.First_Name} {rowData.Surgeon.Middle_Name}
          </div>
        )},
        cellStyle: {
          fontSize: '.7em'
        }
      },
      { title: 'Patient Name', field:'Patient.Last_Name', editable: "never", filtering: false, render: rowData => {
        return(
          <div>
            {rowData.Patient.Last_Name}, {rowData.Patient.First_Name}
          </div>
        )},
        cellStyle: {
          fontSize: '.7em'
        }
      },
      { title: 'DOPO', field:'dateCreated', editable: "never", filtering: 'false', type:'date',
        cellStyle:{
          fontSize: '.7em'
        },
          customSort: (a , b) => {
            a = moment(a.dateCreated).format();
            b = moment(b.dateCreated).format();
            return b > a ? 1 : -1;
          }
      },
      { title: 'DOS', field:'Patient.Date_of_Surgery', editable: "never", filtering: 'false', type: 'date',
        cellStyle: {
          fontSize: '.7em'
        },
          customSort: (a , b) => {
            a = moment(a.Patient.Date_of_Surgery).format();
            b = moment(b.Patient.Date_of_Surgery).format();
            return b > a ? 1 : -1;
          }
      },
      { title: 'Surgery Type', field:'Patient.Surgery_Type', editable: "never", filtering: 'false',
        cellStyle: {
          fontSize: '.7em'
        }
      },
      { title: 'Surgery Side', field:'Patient.Side_of_Body', editable: "never", filtering: 'false',
        cellStyle: {
          fontSize: '.7em'
        }
      },
      { title: 'Status', field:'case_status', filtering: 'false',
        lookup: lookup,
        emptyValue: "New Order",
        cellStyle: {
          background: 'linear-gradient(315deg, #045de9 0%, #09c6f9 74%)',
          backgroundColor: "#045de9",
          color: 'white',
          textAlign: 'center',
          fontSize: '.7em'
        }
      }
    ]
  });

  const classes = useStyles();
  if(loading){
    return(
      <div className={classes.loadingScreen}>
        <div className={classes.loadingLogoWrap}>
          <img className={classes.loadingLogo} src={logo} alt="Lento Medical Innovation" />
        </div>
      </div>
    )
  }

  return(
    <ThemeProvider theme={theme}>
      <main className={classes.page}>
        <div className={classes.shell}>
          <header className={classes.pageHeader}>
            <div>
              <p className={classes.eyebrow}>Case management</p>
              <h1 className={classes.title}>Flagged Cases</h1>
              <p className={classes.subtitle}></p>
            </div>
            <div className={classes.headerMeta}>
              <span className={classes.metaPill}>
                <span className={classes.metaDot} />
                {Array.isArray(state.data) ? state.data.length : 0} {Array.isArray(state.data) && state.data.length === 1 ? 'record' : 'records'}
              </span>
            </div>
          </header>

          <section className={classes.card}>
            <div className={classes.cardIntro}>
              <div>
                <p className={classes.cardLabel}>Flagged case records</p>
                <p className={classes.cardHint}>Search, sort, filter, and review flagged cases from one place.</p>
              </div>
              {hasRole(profile, ['super_admin', 'write_admin']) ? (
                <button type="button" className={classes.actionButton} onClick={handleAssign}>Assign</button>
              ) : null}
            </div>

    <MaterialTable
      title=""
      columns={hasRole(profile, ['super_admin', 'write_admin', 'read_admin']) ? state.adminColumns : state.columns}
      data={state.data}
      icons={tableIcons}
      actions={
        hasRole(profile, ['super_admin', 'write_admin']) ?
        [{
          icon: tableIcons.Flag,
          tooltip: 'Reset Flag',
          onClick: (event, rowData) => {
            setState({...state, dialogFlagOpen: true, rowData})
        }
        }
        ]
        :
        null
      }
      editable={
        hasRole(profile, ['super_admin', 'write_admin']) ?
        {
        onRowUpdate: (newData, oldData) =>
           new Promise((resolve, reject) => {
             setTimeout(() => {
               {
                 {/*const data = [...data.data];
                 const index = data.indexOf(oldData);
                 data[index] = newData;*/}
                 resolve();
                 const data = [...state.data];
                 const index = data.indexOf(oldData);
                 data[index] = newData;

                console.log(newData)
                if(oldData.femur_slot != newData.femur_slot ){
                 if((newData.femur_slot == true) || (newData.femur_slot == false)){
                     axios({
                       url: `https://${api_url}/api/case?case_id=${newData.case_id}&update=slotSkip&femur=${newData.femur_slot == true ? 1 : 0}`,
                       method: 'put',
                       headers: {
                         'x-access-token' : token
                       }
                     }).then(res=> {
                       if(res.data.message){
                         setState({...state, dialogMessageOpen: true, oldData, error: res.data.message})
                       }

                       setState({...state, data})

                     })
                   }
                 }
                 else if(oldData.tibia_slot != newData.tibia_slot){
                   axios({
                     url: `https://${api_url}/api/case?case_id=${newData.case_id}&update=slotSkip&tibia=${newData.tibia_slot == true ? 1 : 0}`,
                     method: 'put',
                     headers: {
                       'x-access-token' : token
                     }
                   }).then(res=> {
                     if(res.data.message){
                       setState({...state, dialogMessageOpen: true, oldData, error: res.data.message})
                     }
                     setState({...state, data})

                   })
                 }
                 else if (oldData.expedite != newData.expedite){
                   console.log("hi")
                   axios({
                     url: `https://${api_url}/api/case?case_id=${oldData.case_id}&update=expedite&expedite=0`,
                     method: 'put',
                     headers: {
                       'x-access-token' : token
                     }
                   }).then(res=> {
                     if(res.data.message){
                       setState({...state, dialogMessageOpen: true, newData, error: res.data.message})
                       window.location.reload()
                     }
                      setState({...state, data})
                      window.location.reload()
                   })
                 }
                 else if (newData.case_status > oldData.case_status || newData.case_status == 1){
                   reject(new Error(newData))
                   alert("Error: Status will not change. Please choose statuses previous to the current status.")

                 }
                 else if (oldData.case_status == 11){
                   reject(new Error(newData))
                   alert("Error: Status will not change. Order has already been shipped.")
                 }
                 else if(oldData.case_status == newData.case_status){
                   if(oldData == newData){
                     reject(new Error(newData))
                     alert("Error: Status will not change. Status already in progress.")
                   }
                   else{
                    axios({
                      url: `https://${api_url}/api/case?case_id=${newData.case_id}&update=edit_patient`,
                      method: 'put',
                      headers: {
                        'x-access-token' : token
                      },
                      data: newData

                    }).then(res=> {
                      if(res.data.message){
                        console.log(newData)
                        setState({...state, dialogMessageOpen: true, newData, error: res.data.message})
                      }
                      else if(res.data.notLoggedIn){
                        setAuthenticated(false)
                        setAuthBody({role: 'visitor'})
                        alert("You have been logged out due to inactivity. Please log in again.")
                      }
                      else{
                        window.location.reload()
                      }
                    })
                 }
               }
                 else {
                   setState({ ...state, data });
                   console.log(newData)
                   console.log(data)
                   console.log(state)
                   axios({
                     url: `https://${api_url}/api/case?case_id=${newData.case_id}&update=change_case_status&change_status=${newData.case_status}`,
                     method: 'put',
                     headers: {
                       'x-access-token' : token
                     }
                   }).then(res=> {
                     console.log("dog");
                     window.location.reload()
                     console.log("dog", res.data)
                   })
                   ;
                 }
               }
               resolve()
             }, 1000);
           })
      }
      :
      null

      }
      localization={{
          pagination: {
              labelDisplayedRows: '{from}-{to} of {count}'
          },
          toolbar: {
              nRowsSelected: '{0} row(s) selected'
          },
          header: {
              actions: 'Edit'
          },
          body: {
              emptyDataSourceMessage: 'No records to display',
              filterRow: {
                  filterTooltip: 'Filter'
              }
          }
      }}
      options={{
        actionsColumnIndex: 9,
        sorting: true,
        pageSize: 20,
        pageSizeOptions: [10, 20, 50, 100],
        filtering: true,
        columnsButton: true,
        draggable: false,
        emptyRowsWhenPaging: false,
        tableLayout: 'fixed',
        showTitle: false,
        headerStyle: {
          backgroundColor: '#f1f6f8',
          color: '#173247',
          fontSize: '13px',
          fontWeight: 700,
          whiteSpace: 'normal'
        },
        rowStyle: {
          color: '#244154',
          fontSize: '14px'
        },
        searchFieldStyle: {
          width: 280,
          maxWidth: '36vw',
          fontSize: '14px'
        }
      }}
      style={{
        width: '100%',
        background: '#ffffff',
        boxShadow: 'none'
      }}
      />
          </section>
        </div>
      </main>
    <Dialog open={state.dialogFlagOpen} onClose={handleClose} aria-labelledby="form-dialog-title" PaperProps={{ className: classes.dialogPaper }}>
      <DialogTitle id="form-dialog-title">
        <span className={classes.dialogTitle}>Reset case flag?</span>
      </DialogTitle>
      <DialogContent>
        <DialogContentText className={classes.dialogText}>
        Flag will reset for Case: {state.rowData ? state.rowData.case_id : null}.
        { state.rowData ?
          state.rowData.case_status == 2 ?
          " Are you sure you want to reset the flag or RESCAN? If RESCAN, please click case and click RESCAN button."
          :
          " Are you sure you want to reset the flag?"

          :
          null
        }
        </DialogContentText>
      </DialogContent>
      <DialogActions className={classes.dialogActions}>
        <button type="button" className={classes.cancelButton} onClick={handleClose}>
          Cancel
        </button>
        <button type="button" className={classes.dangerButton} onClick={handleSubmit}>
          Reset flag
        </button>
      </DialogActions>
    </Dialog>
    <Dialog open={state.dialogMessageOpen} onClose={handleClose} aria-labelledby="form-dialog-title" PaperProps={{ className: classes.dialogPaper }}>
      <DialogTitle id="form-dialog-title">
        <span className={classes.dialogTitle}>Unable to update slot</span>
      </DialogTitle>
      <DialogContent>
        <DialogContentText className={classes.dialogText}>
        {state.oldData ? state.oldData.case_id : null} will not change slot. {state.error ? state.error.replace("_", " ") : null}.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleSlotClose} color="primary" variant="contained">
          OK
        </Button>
      </DialogActions>
    </Dialog>
    </ThemeProvider>
  );
};

export default FlagList;